import { useQuery } from '@tanstack/react-query'
import getProgram from '@/services/ruutsApi/getProgram'
import { queryKeys } from './queryKeys'

// `!= null` rather than a truthiness gate: program SARA has id 0.
export const useProgram = (programId: string | number | undefined) =>
  useQuery({
    queryKey: queryKeys.program(programId),
    queryFn: ({ signal }) => getProgram({ id: programId as string | number, signal }),
    enabled: programId != null,
  })
